<ngx-nativeapp-advert></ngx-nativeapp-advert>

<ul class="row basic_list_informations">
  <li class="col-sm-2" i18n="@@PlanName">Plan Name</li>
  <li *ngIf="contentLoaded" class="col-sm-10">{{ ThePlan.name }}</li>
  <li *ngIf="!contentLoaded" class="col-sm-10"><div class="skeleton-general"></div></li>
</ul>

<ul class="row basic_list_informations">
  <li class="col-sm-2" i18n="@@PlanDescription">
  Plan Description
  </li>

  <li *ngIf="contentLoaded" class="col-sm-10">{{ ThePlan.description }}</li>
  <li *ngIf="!contentLoaded" class="col-sm-10"><div class="skeleton-general"></div></li>
</ul>

<ul class="row basic_list_informations">
  <li class="col-sm-2" i18n="@@PlanNotes">Plan Notes</li>

  <li *ngIf="contentLoaded" class="col-sm-10">{{ ThePlan.notes }}</li>
  <li *ngIf="!contentLoaded" class="col-sm-10"><div class="skeleton-general"></div></li>
</ul>


<div style="min-height: 600px;padding-top: 20px; margin-bottom: 30px">



<mat-tab-group
  [(selectedIndex)]="SelectedDayIndex"
  (selectedTabChange)="onDayChanged($event)"
  animationDuration="0ms"

>
  <mat-tab
    *ngFor="let day of TheDays; let index = index"
    label="Day {{ day.order }} ({{ day.name }})"
  >



      <app-fitness-plan-day-mobile
      *ngIf="SelectedDayIndex==index"
      #PlanDay
      [PatientID]="PatientID"
      [PatientName]="OriginalPatientName"
      [IsPreferredUnitImperial]="IsPreferredUnitImperial"
      [Day]="day"
      [PlanDays]="TheDays"
    >
    </app-fitness-plan-day-mobile>
        
  
  





  
  </mat-tab>
</mat-tab-group>
</div>